export const DATADOG_APPS_IDS = {
    'frontend-cp-deposits': 'bf7c1806-4278-47c3-ba6b-b8337ab4d207',
    'frontend-obs': '38c83a51-8977-493b-8e06-1357bef64227',
    'frontend-cp-orders-wealth-management': 'cf6a7baa-2e2b-4ef8-a5f9-51f2ce988ebb',
    'frontend-cp-dashboard-investments': 'c4fcface-63e7-4f48-8c68-af4c79204cf9',
    'frontend-cp-customer-details': '19ada740-22d8-4ad4-b9cb-631d14993dfb',
    'frontend-cp-customer-data': '4549a9b3-e30b-46b6-8fc2-e75e3a88913e',
    'frontend-cp-account-withdrawal': '4d4ab56b-c096-4d43-aa15-6af1088fe0eb',
    'frontend-cp-account-transactions': '547821aa-bc0d-4860-b02d-fb97e4aca53c',
    'frontend-cp-documents': '23acfbcb-82d1-4050-9c57-43d7fedb392f',
    'frontend-cp-exemption-order': '0f80a8cf-10c6-4587-98fa-965a6b328767',
    'frontend-cp-identification': '7bdcf894-6fe1-4c8f-b29a-f599b8931ae1',
    'frontend-cp-notifications': '84a6da5f-e81d-409b-8ab1-540426183cb1',
    'frontend-cp-payment-methods': 'd3ca2a4a-fbaa-47eb-9bbd-2dd72b39b710',
    'frontend-cp-postbox': 'd97dc31d-32ee-466a-8eec-903303e6b7f9',
    'frontend-cp-user-account': 'ec792d03-d3a8-4197-b859-e46bb294c018',
    'frontend-cp-login': '3e58dccd-7e1c-4976-a90f-fc41e2c17c13',
    'frontend-cp-crypto-lp': 'e5ef4078-2d74-416e-8960-8ef7a0e2aba6',
    'frontend-cp-invest-parent-lp': 'ca324fd3-f219-4aca-83d5-6e5d0bb8c206',
    'frontend-cp-private-equity-lp': '0f303023-52dd-4f87-9f2a-05c9e78a4f9b',
    'frontend-cp-private-equity-onboarding': 'c4245c1e-8c47-4fb3-81d7-c224bc4ce474',
    'frontend-cp-registration': '7988aca1-af1d-4a7c-87d9-730f9a0e3f51',
    'frontend-customer-portal': '5d4b62a8-6aa3-421d-8c66-8220da7af3f5',
};
//# sourceMappingURL=dataDog-apps-ids.js.map